module.exports = __webpack_public_path__ + "img/pocket_buttons.93b478e6.png";